import { render, staticRenderFns } from "./DashNegotiationListFileReview.vue?vue&type=template&id=60141c1d&scoped=true&"
import script from "./DashNegotiationListFileReview.vue?vue&type=script&lang=js&"
export * from "./DashNegotiationListFileReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60141c1d",
  null
  
)

export default component.exports